import {
  FaBolt,
  FaDatabase,
  FaExchangeAlt,
} from "@onemind-services-llc/react-icons-ng/fa";
import { MdStorage } from "@onemind-services-llc/react-icons-ng/md";
import HeroBg from "public/marketplace-apps/hero/Hero-section-redis.png";

export const REDIS_CONSTANTS = {
  HERO: {
    title: "OneMind Services — Redis (One-Click Application) ",
    desc: "Redis with OneMind Services offers a fully managed, high-performance message broker solution. Experience seamless scalability, robust security, and effortless management, allowing you to focus on building your applications without the hassle of message queue administration.",
    button: {
      label: "Try Now",
      link: "contact-us",
    },
    image: HeroBg,
  },
  INTRO: {
    title: "General Information",
    text: "Redis is an open-source, in-memory key-value data store known for its speed and versatility. It supports various data structures including strings, hashes, lists, sets, and streams, and is commonly used as a cache, message broker, or lightweight NoSQL database.  ",
  },
  WHY_ONEMIND: {
    title: "Deploy Effortlessly with OneMind Ease ",
    desc: [
      {
        highlight: "One-Click Installation",
        text: " One-Click Installation : Launch a fully configured and secure Redis instance in minutes—no need to install or manage dependencies. ",
      },
      {
        highlight: "Global Reach",
        text: " Global Reach : Deploy in any of our multiple data-center regions to keep latency low and performance high. ",
      },
      {
        highlight: "Pre‑Configured Setup",
        text: " Pre‑Configured Setup : Includes Redis server, default configuration, and optimized memory settings.  ",
      },
    ],
    marginTop: 0,
    btnText: "Start Now",
  },
  GET_STARTED: {
    title: "Access & Administration ",
    desc: [
      {
        text: "Once deployed, you’ll receive in your console:",
      },
      {
        text: " Username :",
        highlight: "guest",
      },
      {
        text: " Password :",
        highlight: "<generated-password>",
      },
    ],
    connection: {
      text: "Connect using: ",
      command: "redis-cli -h <YOUR_INSTANCE_IP> -a <generated password> ",
    },
    installation: {
      heading: "Installation Location -",
      text: "The configuration file is located in the directory",
      location: " /etc/redis/redis.conf ",
    },
    ports: {
      heading: "Ports Used ",
      text: "Application, besides standard Ubuntu Ports (53/22), uses: ",
      list: ["6379"],
    },
    note: "Note : Find the configuration file at /etc/redis/redis.conf for customized tweaks or backup. ",
  },
  FEATURES: {
    items: [
      {
        icon: FaBolt,
        title: "In-Memory Speed",
        text: "All operations occur in memory, providing extremely low latency and high throughput.",
      },
      {
        icon: FaDatabase,
        title: "Data Structures",
        text: "Supports advanced types like lists, sets, hashes, bitmaps, and geospatial indexes.",
      },
      {
        icon: MdStorage,
        title: "Persistence Options",
        text: "Offers RDB snapshots and AOF (Append Only File) for durable data storage.",
      },
      {
        icon: FaExchangeAlt,
        title: "Pub/Sub Messaging",
        text: "Supports publish-subscribe messaging patterns for real-time applications.",
      },
    ],
  },
  BENEFITS: {
    title: "Resilience & Scaling ",
    options: [
      {
        label: "Backups & Snapshots",
        text: "Use OneMind’s snapshot feature or native RDB/AOF persistence for backups. ",
      },
      {
        label: "Security Out of the Box",
        text: "Includes password protection, IP binding, and TLS support.  ",
      },
      {
        label: "Scalable Architecture",
        text: "Easily scale with Redis Sentinel for HA and Redis Cluster for partitioning. ",
      },
    ],
  },
  SUPPORT: {
    docsText: "Redis Official Docs",
    docsLink: "https://redis.io/docs/latest/",
  },
};
